import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-entity-field-masive-options',
  templateUrl: './entity-field-masive-options.component.html',
  styleUrls: ['./entity-field-masive-options.component.scss']
})
export class EntityFieldMasiveOptionsComponent implements OnInit {

  public text: string = "";

  constructor(
    private dynamicDialogRef: DynamicDialogRef,
    private messageService: MessageService,

  ) { }

  ngOnInit(): void {

  }

  cancel() {
    this.dynamicDialogRef.close();
  }
  save() {
    var finalItems = [];

    if (this.text.includes("|") || this.text.includes("\t")) {
      var items = this.text.split("\n").filter(m => m.length > 0);
      /*
      items.forEach(item => {
        if (this.text.includes("|")) {
          var keyValue = item.split("|");
          keyValue[0] = keyValue[0].trim();
          keyValue[1] = keyValue[1].trim();
        } else {
          var keyValue = item.split("\t");
        }
        if(keyValue[0].length == 0) this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: "Ninguna de las claves puede estar" });
        finalItems.push(keyValue);
      });
      */
      var errorLine = 0;

      for (let index = 0; index < items.length; index++) {
        const item = items[index];
        if (this.text.includes("|")) {
          var keyValue = item.split("|");
          keyValue[0] = keyValue[0].trim();
          keyValue[1] = keyValue[1].trim();
        } else {
          var keyValue = item.split("\t");
        }
        if (keyValue[0].length == 0) {
          errorLine = index+1;
          this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: "Ninguna de las claves puede estar vacía. (Línea "+errorLine+")" });
          break;
        } else {
          finalItems.push(keyValue);
        }
      }
      if (errorLine == 0) this.dynamicDialogRef.close(finalItems);
    } else {
      this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: "Debe separar la clave del valor con el símbolo '|'." });
    }
  }
}
